import { usePresenterOrAttendee } from '../context/AttendeeAndPresenterProvider';
import { LinearProgress } from '@mui/material';

const QuestionComponent = ({ isReadOnly }) => {
  const { currentQuestion, userAnswers, gameState, questions } = usePresenterOrAttendee();

  console.log('currentQuestion', currentQuestion, 'questions', questions, gameState);

  if (!currentQuestion) {
    if (gameState.state === 'initial') {
      return <h1>Waiting for game to start...</h1>;
    }
    return '';
  }

  return (
    <div className="presenter-question-wrapper">
      <h2>{`QUESTION ${currentQuestion.id} of ${Object.keys(questions).length}`} </h2>
      <h2 dangerouslySetInnerHTML={{ __html: `${currentQuestion.text}` }} />
      <h4>Total answers: {userAnswers.totalAnswerCount || 0}</h4>

      {currentQuestion.answers.map((answer, index) => {
        const percentage = userAnswers?.[answer.id] || 0;
        return (
          <div key={index}>
            <h3
              dangerouslySetInnerHTML={{ __html: `${answer.text} ${percentage}%` }}
              style={answer.isCorrect ? { color: 'blue' } : null}
            />
            <LinearProgress variant="determinate" value={percentage} />
          </div>
        );
      })}
    </div>
  );
};

export default QuestionComponent;
